<template>
  <AgGridRenderList
    ref="agGrid"
    :columnDefs="columnDefs"
    :rowData="rowData"
    :totalRows="totalRows"
    :lastPage="lastPage"
    :loading="paginationLoading"
    @updatePagination="updatePagination"
    @updateItemPerPage="updateItemPerPage"
  />
</template>

<script>
import General from "../../../../../../../Mixins/general";
import AgvmenuCustom from "../../../../../components/general/AgGridComponents/Ag-vmenuCustom.vue";
import moment from "moment-jalaali";

export default {
  components: { AgvmenuCustom },
  props: {
    callRefresh: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      totalRows: null,
      lastPage: null,
      invoiceIds: null,
      filterDialog: false,
      toDate: null,
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      account: null,
      sellStatus: null,
      currencyFilter: null,
      fromAmount: null,
      fromNumber: null,
      fromDate: null,
      toAmount: null,
      toNumber: null,
      toDate: null,
      tag: null,
      category: null,
      branch: null,
      entrepot: null,
      lockStatus: null,
      registerar: null,
      payedStatus: null,
      fromTime: null,
      toTime: null,
      customFields: null,
      paginationLoading: false,
      showActionColumn: false,
    };
  },
  mixins: [General],
  mounted() {
    this.columnDefs = [
      {
        headerName: "#",
        colId: "rowNumber",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 70,
        maxWidth: 70,
        minWidth: 70,
        resizable: false,
        pinned: "right",
      },
      {
        headerName: this.$t("name"),
        field: "name",
        valueGetter: (params) => {
          if (
            params.data &&
            params.data.employee.user &&
            params.data.employee.user.name
          ) {
            return params.data.employee.user.name;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 160,
        minWidth: 160,
        sortable: true,
      },
      {
        headerName: this.$t("personnelCode"),
        field: "personnelCode",
        valueGetter: (params) => {
          if (params.data?.isSummary) {
            return "";
          }
          return params.data?.employee?.personnely ?? this.$t("haveNot");
        },
        width: 130,
        minWidth: 130,
        sortable: true,
      },
      {
        headerName: this.$t("national-code"),
        field: "national-code",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data?.isSummary) {
            return "";
          }
          return params.data?.employee?.user?.national_code ?? this.$t("haveNot");
        },
        width: 185,
        minWidth: 185,
        sortable: true,
      },
      {
        headerName: this.$t("performance_"),
        field: "performance_",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data?.daily_work !== null) {
            return params.data?.daily_work;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 185,
        minWidth: 185,
        sortable: true,
      },
      {
        headerName: this.$t("peyment"),
        field: "peyment",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.benefit !== null) {
            return this.$numberFormat(params.data.benefit);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 185,
        minWidth: 185,
        sortable: true,
      },
      {
        headerName: this.$t("deductions"),
        field: "deductions",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data) {
            const deduction = Number(params.data.deductions) || 0;
            const tax = Number(params.data.tax) || 0;
            const insurance = Number(params.data.employee_insurance) || 0;
            const total_deduction = deduction + tax + insurance;
            return this.$numberFormat(total_deduction);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 185,
        minWidth: 185,
        sortable: true,
      },
      {
        headerName: this.$t("netPay"),
        field: "netpay",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data) {
            const deduction = Number(params.data.deductions) || 0;
            const tax = Number(params.data.tax) || 0;
            const insurance = Number(params.data.employee_insurance) || 0;
            const total = deduction + tax + insurance;
            const peyment = params.data.benefit;
            const res = peyment - total;
            return this.$numberFormat(res);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 180,
        minWidth: 180,
        sortable: true,
      },
      {
        headerName: "",
        field: "status",
        cellRenderer: (params) => {
          if (params.data?.isSummary) {
            const button = document.createElement("button");
            button.innerText = this.$t("salary_slip_group");
            button.style.background = "#f9f9f9";
            button.style.border = "1px solid gray";
            button.style.padding = "4px 15px";
            button.style.borderRadius = "4px";
            button.style.cursor = "pointer";
            button.style.fontSize = "10px";
            button.addEventListener("click", () => {
              this.handleGroupPrint(params.data);
            });
            return button;
          }
          const button = document.createElement("button");
          button.innerText = this.$t("salary_slip");
          button.style.background = "#f9f9f9";
          button.style.border = "1px solid gray";
          button.style.padding = "4px 15px";
          button.style.borderRadius = "4px";
          button.style.cursor = "pointer";
          button.style.fontSize = "10px";
          button.addEventListener("click", () => {
            this.handleStatusClick(params.data);
          });
          return button;
        },
        width: 150,
        minWidth: 150,
        sortable: false,
      },
    ];
  },
  watch: {
    callRefresh: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.getItems();
          this.$emit("initial-Loading-is", false);
        }
      },
    },
  },
  beforeMount() {
    this.getItems();
  },
  methods: {
    handleStatusClick(row) {
      console.log("response");
      this.$emit("print-data", row);
    },
    handleGroupPrint() {
      const rows = this.rowData.filter((r) => !r.isSummary);
      this.$emit("print-data", this.rowData);
    },
    generateTime(val) {
      let format = "jYYYY/jMM/jDD";
      let date = val;
      if (!date) return null;
      return moment(date).locale("fa").format(format);
    },
    getItems(isPaginate = false) {
      var app = this;
      if (!isPaginate) {
        app.$emit("initial-Loading-is", true);
      }
      const id_ = app.$route.query.id;
      this.paginationLoading = isPaginate;
      app.$axios
        .get(app.$endpoint + "salary/employee-list/" + id_, {
          params: {
            options: app.optionsNew,
          },
        })
        .then((response) => {
          const data = [...response.data.salaries.data];
          const numericFields = ["performance_", "peyment", "deductions", "netPay"];
          const summaryRow = {
            isSummary: true,
            employee: {
              user: { name: "مجموع" },
            },
            benefit: 0,
            deduction: 0,
            netPay: 0,
          };

          data.forEach((row) => {
            const benefit = Number(row.benefit) || 0;
            const deduction = Number(row.deductions) || 0;
            const tax = Number(row.tax) || 0;
            const insurance = Number(row.employee_insurance) || 0;

            const totalDeduction = deduction + tax + insurance;
            const net = benefit - totalDeduction;

            summaryRow.benefit += benefit;
            summaryRow.deduction += totalDeduction;
            summaryRow.netPay += net;
          });

          data.push(summaryRow);

          app.rowData = data;
          app.totalRows = response.data.salaries.total;
          app.lastPage = response.data.salaries.last_page;
          app.$emit("workshopItems", {
            items: response.data.workshop,
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
          app.paginationLoading = false;
        });
    },
    refreshData() {
      this.getItems(true);
    },
    updatePagination(value) {
      this.optionsNew.page = value;
      this.getItems(true);
    },
    updateItemPerPage(value) {
      this.optionsNew.itemsPerPage = value;
      this.optionsNew.page = 1;
      this.getItems(true);
    },
    editAction(rowData) {
      this.$router.push({
        name: "salery_operations_list",
        query: {
          id: rowData.id,
        },
      });
    },
    deleteAction(rowData) {
      var app = this;
      let salaryFactorConfigId = rowData.id;
      app.$axios
        .delete(app.$endpoint + "salary-factor-config/" + salaryFactorConfigId)
        .then((response) => {})
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          this.getItems(true);
          app.paginationLoading = false;
        });
    },
    goToDocuments(rowData, tab) {
      this.$router.push({
        name: "salary_documents",
        query: {
          id: rowData.id,
          tab: tab,
        },
      });
    },
  },
};
</script>

<style scoped>
.wrapperTable {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
::v-deep(.v-input .v-label.v-label--active) {
  top: 8px !important;
}
.v-skeleton-loader__list-item.v-skeleton-loader__bone {
  align-content: unset;
  align-items: flex-start;
  padding: 0;
}
.theme--light.v-skeleton-loader .v-skeleton-loader__text {
  background: rgb(146 139 139 / 12%);
}
.v-skeleton-loader__text {
  height: 30px;
}
.v-skeleton-loader__list-item {
  height: 41px;
}
</style>
